import { CodeNode } from '@lexical/code';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';
import { HeadingNode, QuoteNode } from '@lexical/rich-text';

export const EDITOR_NAMESPACE = 'lexical-editor';

export const EDITOR_NODES = [
  AutoLinkNode,
  CodeNode,
  HeadingNode,
  LinkNode,
  ListNode,
  ListItemNode,
  QuoteNode,
];

export const SHARED_LEXICAL_CONFIG = {
  namespace: EDITOR_NAMESPACE,
  nodes: EDITOR_NODES,
  theme: {
    link: 'cursor-pointer underline text-blue-600 hover:text-blue-800',
  },
  onError: (error: Error) => {
    console.error(error);
  },
};
